module.exports = __webpack_public_path__ + "img/qr_code_b.3d7b70fd.svg";